import type { FunctionComponent } from "react";

export const HookRunner: FunctionComponent<{ hook: () => void }> = ({ hook }) => {
  hook();
  return null;
};
HookRunner.displayName = "HookRunner";
